export function membersFunc() {
  const modal = document.getElementById('members-modal');
  const dataEl = document.getElementById('members-modal-data');
  if (!modal || !dataEl) return;

  let members = [];
  try {
    members = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  const frameEl = modal.querySelector('.p-members-modal__frame');
  const imageEl = modal.querySelector('.p-members-modal__image');
  const deptEl = modal.querySelector('.p-members-modal__dept');
  const nameEnEl = modal.querySelector('.p-members-modal__name-en');
  const nameSuffixEl = modal.querySelector('.p-members-modal__name-suffix');
  const tenureEl = modal.querySelector('.p-members-modal__tenure');
  const catchphraseEl = modal.querySelector('.p-members-modal__catchphrase');
  const leadEl = modal.querySelector('.p-members-modal__lead');
  const questionsEl = modal.querySelector('.p-members-modal__questions');
  let lastFocus = null;

  const openModal = (index) => {
    const member = members[index];
    if (!member) return;

    lastFocus = document.activeElement;
    if (frameEl) frameEl.src = member.frame;
    if (imageEl) imageEl.src = member.image;
    if (deptEl) deptEl.textContent = member.dept;
    if (nameEnEl) nameEnEl.textContent = member.name_en;
    if (nameSuffixEl) nameSuffixEl.textContent = member.name_suffix || '';
    if (tenureEl) {
      tenureEl.textContent = member.tenure || '';
      tenureEl.hidden = !member.tenure;
    }
    if (catchphraseEl) catchphraseEl.innerHTML = member.catchphrase || '';
    if (leadEl) leadEl.innerHTML = member.lead || '';

    if (questionsEl) {
      questionsEl.innerHTML = (member.questions || [])
        .map(
          (item) =>
            '<div class="p-members-modal__item">' +
            '<p class="p-members-modal__question">' + (item.q || '') + '</p>' +
            '<span class="p-members-modal__line" aria-hidden="true"></span>' +
            '<p class="p-members-modal__answer">' + (item.a || '') + '</p>' +
            '</div>'
        )
        .join('');
    }

    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-members-modal-open');
    const closeTop = modal.querySelector('.p-members-modal__close-top');
    if (closeTop) closeTop.focus();
  };

  const closeModal = () => {
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-members-modal-open');
    if (lastFocus) lastFocus.focus();
  };

  document.addEventListener('click', (e) => {
    const openBtn = e.target.closest('[data-member-open]');
    if (openBtn) {
      openModal(parseInt(openBtn.getAttribute('data-member-open'), 10));
      return;
    }

    const closeBtn = e.target.closest('[data-member-close]');
    if (closeBtn && modal.contains(closeBtn)) {
      closeModal();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !modal.hidden) closeModal();
  });
}
